import { addYears, format } from "date-fns";

export const calculateDateWithOffset = (
    yearsOffset?: number,
    date?: string,
): string => {
    const workingDate = date ? new Date(date) : new Date();
    const newDate = yearsOffset
        ? addYears(workingDate, yearsOffset)
        : workingDate;
    return format(newDate, "yyyy-MM-dd");
};
